<section class="repository">
    <div class="content">
        <div [ngSwitch]="latestRepoState?.buildStatus" class="d-flex align-items-center">
            <ng-container *ngSwitchCase="buildStatusValues.Succeeded">
                <ca-icon name="checkmark" size="s" class="ca-color-success" data-uit="success-checkmark"></ca-icon>
                {{ 'MODULES.DETAIL.BUILD_STATUS.BUILD_STATUS' | translate }}: {{ 'MODULES.DETAIL.BUILD_STATUS.SUCCEEDED' | translate }}
            </ng-container>
            <ng-container *ngSwitchCase="buildStatusValues.Stopped">
                <ca-icon name="error" size="s" class="ca-color-icon-error" [removeSVGAttributes]="['stroke']"></ca-icon>
                {{ 'MODULES.DETAIL.BUILD_STATUS.BUILD_STATUS' | translate }}: {{ 'MODULES.DETAIL.BUILD_STATUS.STOPPED' | translate }}
            </ng-container>
            <ng-container *ngSwitchCase="buildStatusValues.PartiallySucceeded">
                <ca-icon name="warning" size="s" class="ca-color-icon-warning" [removeSVGAttributes]="['stroke']"></ca-icon>
                {{ 'MODULES.DETAIL.BUILD_STATUS.BUILD_STATUS' | translate }}: {{ 'MODULES.DETAIL.BUILD_STATUS.PARTIALLY_SUCCEEDED' | translate }}
            </ng-container>
            <ng-container *ngSwitchCase="buildStatusValues.Failed">
                <ca-icon name="error" size="s" class="ca-color-icon-error" [removeSVGAttributes]="['stroke']"></ca-icon>
                {{ 'MODULES.DETAIL.BUILD_STATUS.BUILD_STATUS' | translate }}: {{ 'MODULES.DETAIL.BUILD_STATUS.FAILED' | translate }}
            </ng-container>
            <ng-container *ngSwitchCase="buildStatusValues.Running">
                <span class="building-module-icon"></span>
                {{ 'MODULES.DETAIL.BUILD_STATUS.BUILD_STATUS' | translate }}: {{ 'MODULES.DETAIL.BUILD_STATUS.RUNNING' | translate }}
            </ng-container>
            <ng-container *ngSwitchCase="buildStatusValues.NotRunnable">
                <ca-icon name="warning" size="s" class="ca-color-icon-warning" [removeSVGAttributes]="['stroke']"></ca-icon>
                {{ 'MODULES.DETAIL.BUILD_STATUS.BUILD_STATUS' | translate }}: {{ 'MODULES.DETAIL.BUILD_STATUS.NOT_RUNNABLE' | translate }}
            </ng-container>
            <ng-container *ngSwitchCase="buildStatusValues.Initializing">
                <span class="building-module-icon"></span>
                {{ 'MODULES.DETAIL.BUILD_STATUS.BUILD_STATUS' | translate }}: {{ 'MODULES.DETAIL.BUILD_STATUS.INITIALIZING' | translate }}
            </ng-container>
            <ng-container *ngSwitchCase="buildStatusValues.Unknown">
                <ca-icon name="warning" size="s" class="ca-color-icon-warning" [removeSVGAttributes]="['stroke']"></ca-icon>
                {{ 'MODULES.DETAIL.BUILD_STATUS.BUILD_STATUS' | translate }}: {{ 'MODULES.DETAIL.BUILD_STATUS.UNKNOWN' | translate }}
            </ng-container>
        </div>
        <a class="preview" *ngIf="hasLog" title="Preview" (click)="previewLog()">Open logs errors</a>
        <span class="me-0 text-end">
            <div *ngIf="buildHasRun">Built at {{ latestRepoState?.builtAt | date: 'dd.MM.yyyy | HH:mm:ss' }}</div>
        </span>
    </div>
</section>
